module.exports = __webpack_public_path__ + "img/author_thumbnail-400x300.5dd6a891.jpg";